import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20, GongsishuIcon, YangbenshuIcon } from '@styled/icon';
import moIndustryChain, {
  initIndustryChain, hoverIndustry2, hoverIndustry3,
  leaveIndustry2, leaveIndustry3,
} from './store';
import Empty from '@comp/empty';
import moUser from '@store/user';
import moIndex from '../../store/index';
import { locateValue } from '@/tool';

interface IProps {}
interface IState {}

const IndustryChain = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isLogin } = moUser;
  const { chainArr, categoryArr, isCategory } = moIndustryChain;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="industry-chain_10">
      <strong className="sub-11 sub-001">产业链分布</strong>
      {!isEmpty(chainArr) ? (
        <section className={[
          "chain-10", !isMock ? '' : 'mock-100',
        ].join(' ')}>
          <section className="chain-head_10">
            {isCategory ? <span className="one-1">分类</span> : null}
            <span className="one-2">二级行业</span>
            <span className="one-3">代表企业</span>
          </section>
          {isCategory ? (
            <section className="chain-content_10">
              {chainArr.map((item: any, index: number) => (
                <section key={index} className="content-155">
                  <p className="type-105">
                    <b className={[
                      item.active ? 'active' : '',
                      item.hover ? 'hover' : '',
                    ].join(' ')}>{item.chain}
                    </b>
                  </p>
                  <section className="section-109">
                    {item.list?.map((industry: any, i: number) => (
                      <section key={i} onMouseEnter={() => hoverIndustry3(industry.industry_name)}
                        onMouseLeave={() => leaveIndustry3(industry.industry_name)}
                        className="section-111">
                        <strong className={[
                          industry.hover ? 'hover' : '',
                          industry.active ? 'active' : '',
                        ].join(' ')}>{industry.industry_name}
                        </strong>
                        <section className={[
                          'com-11',
                          industry.hover ? 'hover': '',
                          industry.active ? 'active' : '',
                        ].join(' ')}>
                          <p className="line-165">
                            {industry.company_list?.map((child: any, idx: number) => (
                              <span key={idx}>
                                {child}
                                {idx !== industry.company_list?.length - 1 ? <i>、</i> : null}
                              </span>
                            ))}
                          </p>
                          <section className="line-166">
                            <p className="line-167">
                              <GongsishuIcon color={Color.blackColor(1)} />
                              {industry.hover ? (
                                <span className={['text-190', industry.active ? 'active-190' : ''].join(' ')}>公司数量</span>
                              ) : null}
                              <span className="text-191">{locateValue(industry.company_count)}</span>
                            </p>
                            <p className="line-167 line-169">
                              <YangbenshuIcon color={Color.blackColor(1)} />
                              {industry.hover ? (
                                <span className={['text-190', industry.active ? 'active-190' : ''].join(' ')}>样本数量</span>
                              ) : null}
                              <span className="text-191">{locateValue(industry.sample_count)}</span>
                            </p>
                          </section>
                        </section>
                      </section>
                    ))}
                  </section>
                </section>
              ))}
            </section>
          ) : (
            <section className="chain-content_10">
              {chainArr.map((industry: any, index: number) => (
                <section key={index} className="content-155">
                  <section className="section-109">
                    <section onMouseEnter={() => hoverIndustry2(industry.industry_name)}
                      onMouseLeave={() => leaveIndustry2(industry.industry_name)}
                      className="section-111">
                      <strong className={[
                        industry.hover ? 'hover' : '',
                        industry.active ? 'active' : '',
                      ].join(' ')}>{industry.industry_name}
                      </strong>
                      <section className={[
                        'com-11',
                        industry.hover ? 'hover': '',
                        industry.active ? 'active' : '',
                      ].join(' ')}>
                        <p className="line-165">
                          {industry.company_list?.map((child: any, idx: number) => (
                            <span key={idx}>
                              {child}
                              {idx !== industry.company_list?.length - 1 ? <i>、</i> : null}
                            </span>
                          ))}
                        </p>
                        <section className="line-166">
                          <p className="line-167">
                            <GongsishuIcon color={Color.blackColor(1)} />
                            {industry.hover ? (
                              <span className={['text-190', industry.active ? 'active-190' : ''].join(' ')}>公司数量</span>
                            ) : null}
                            <span className="text-191">{locateValue(industry.company_count)}</span>
                          </p>
                          <p className="line-167 line-169">
                            <YangbenshuIcon color={Color.blackColor(1)} />
                            {industry.hover ? (
                              <span className={['text-190', industry.active ? 'active-190' : ''].join(' ')}>样本数量</span>
                            ) : null}
                            <span className="text-191">{locateValue(industry.sample_count)}</span>
                          </p>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              ))}
            </section>
          )}
        </section>
      ) : <Empty padding="50px 0" />}
    </section>
  );
};

export default observer(IndustryChain);
